import React, { useState, useEffect, useRef } from 'react';
import '../Wordpress/Wordpress.scss';

import { animateScroll as scroll } from "react-scroll";
import { Link } from 'react-router-dom';
import axios from 'axios';
import API from '../../../api';
import useMobile from "../../../hooks/useMobile";
import Loader from "../../Loader/Loader";
import PageMeta from "../../PageMeta/PageMeta";
import CustomSchema from "../../CustomSchema/CustomSchema";
import PostList from '../../Blog/Categories/Posts/PostList';
import PostProjects from "../../PostProjects/PostProjects";
import PostOtherTechnologies from "../../PostOtherTechnologies/PostOtherTechnologies";

const Wordpress = (props) => {
    const [page_data, setPage_data] = useState([]);
    const [yoast_meta, setYoast_meta] = useState([]);
    const [loaded_status, setLoaded_status] = useState(false);
    const [lefSideBarHeight, setLefSideBarHeight] = useState(0);
    const [lastPosts, setLastPosts] = useState([]);
    const postContentsRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [postOptions, setPostOptions] = useState([]);
    const isMobile = useMobile();

    const loadData = async () => {
        setLoaded_status(false)

        const responseContent = await axios.get(API.basePath + '/wp-json/acf/v3/options/post-general-settings')
        setPostOptions(responseContent.data);

        const responseData = await axios.get(API.basePath + '/wp-json/wp/v2/pages?slug=wordpress')
        setPage_data(responseData.data[0]);
        setYoast_meta(responseData.data[0]);
        setLoaded_status(true);
    }

    const loadPosts = async () => {
        const API_POST_PER_PAGE = 3;
        const offset = currentPage * API_POST_PER_PAGE;
        const responsePosts = await axios
            .get(
                API.basePath +
                '/wp-json/wp/v2/posts?tags=' + page_data.acf.relevante_articles_id + '&per_page=' +
                API_POST_PER_PAGE +
                '&offset=' +
                offset
            )
        const recentPosts = [];
        responsePosts.data.forEach((item) => {
            recentPosts.push(item)
        })
        const newRecentPosts = recentPosts.slice(0, 3)
        setLastPosts(newRecentPosts);
    }

    useEffect(() => {
        if(!(Object.keys(page_data).length === 0)) {
            loadPosts()
        }
    }, [page_data])

    function contentsHeight() {
        if (postContentsRef.current !== null) {
            setLefSideBarHeight(postContentsRef.current.offsetHeight);
        }
    }

    document.querySelectorAll('.contents a').forEach((link) => {
        link.onclick = function (e) {
            e.preventDefault()
            let bannerHeight = document.querySelector('.wordpress__banner').offsetHeight;
            let section = document.querySelector(link.getAttribute('href')).offsetTop + bannerHeight;
            scroll.scrollTo(section, {
                duration: 700,
                delay: 0,
                smooth: "easeOutCubic",
                offset: -50,
            });
        };
    })

    useEffect(() => {
        document.getElementById("page").style.overflow = "visible";
        loadData();
        props.setContactElements();
    }, []);

    useEffect(() => {
        contentsHeight()
    }, [postContentsRef.current])

    if (loaded_status) {
        return (
            <>
                <PageMeta metaData={yoast_meta || null} hreflangs={page_data.acf['hreflang_list'] || null} />
                <CustomSchema schema={page_data.schema} />
                <div className="wordpress">
                    <div className="wordpress__banner">
                        <div className="wordpress__banner_left">
                            <div className="wordpress__banner_left--wrapper">
                                <h1 dangerouslySetInnerHTML={{ __html: page_data.acf.banner.title }} />
                                <p>{page_data.acf.banner.text}</p>
                                <img src={page_data.acf.banner.logo.url} alt={page_data.acf.banner.logo.alt} />
                            </div>
                        </div>
                        <div className="wordpress__banner_right">
                            <img className="wordpress__banner_right--image" src={page_data.acf.banner.image.url} alt={page_data.acf.banner.image.alt} />
                            <img className="wordpress__banner_right--background" src={page_data.acf.banner.background_image.url} alt={page_data.acf.banner.background_image.alt} />
                        </div>
                    </div>
                    <div className="wordpress__content">
                        <div className={lefSideBarHeight <= window.innerHeight - 100 && lefSideBarHeight !== 0 ? "wordpress__content-left small" : "wordpress__content-left"} ref={postContentsRef}>
                            {window.innerWidth >= 992 &&
                                <div className="post-contents">
                                    <div className="contents-title">{page_data.acf.contents.header}</div>
                                    <ol className="contents">
                                        {
                                            page_data.acf.contents.list.map((item, key) => {
                                                return (
                                                    <li key={key}>
                                                        <a href={item.href}><p>{item.text}</p></a>
                                                        {item.sublist &&
                                                            <ol>
                                                                {
                                                                    item.sublist.map((sublist_item, key) => {
                                                                        return (
                                                                            <li key={key}>
                                                                                <a href={sublist_item.href}><p>{sublist_item.text}</p></a>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ol>
                                                        }
                                                    </li>
                                                )
                                            })
                                        }
                                    </ol>
                                </div>
                            }
                        </div>
                        <div className="wordpress__content-inner">
                            <div className="wordpress__breadcrumbs">
                                <Link to='/' className="home-link">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="12" fill="url(#paint0_linear_10126_3637)"/>
                                        <path d="M18.9692 17.4411C18.9729 17.6282 18.9393 17.8141 18.8705 17.9881C18.8016 18.162 18.6989 18.3205 18.5683 18.4542C18.4377 18.588 18.2818 18.6943 18.1098 18.767C17.9377 18.8397 17.7529 18.8774 17.5662 18.8777C17.3779 18.878 17.1914 18.841 17.0173 18.7689C16.8433 18.6968 16.6851 18.591 16.552 18.4575C16.4188 18.3241 16.3132 18.1656 16.2413 17.9912C16.1693 17.8167 16.1324 17.6298 16.1327 17.4411V16.8297C15.4922 17.8996 13.7232 19 11.7406 19C8.05005 19 5 15.8821 5 12C5.00066 11.0784 5.18279 10.1659 5.53594 9.31497C5.8891 8.464 6.40633 7.69123 7.05802 7.04096C7.7097 6.39068 8.48301 5.87568 9.33365 5.52546C10.1843 5.17524 11.0955 4.99669 12.0151 5.00005C16.3462 5.00005 19.0302 8.24021 18.9997 12L18.9692 17.4411ZM12.0151 7.64924C9.57508 7.64924 7.98905 9.60556 7.98905 11.9898C7.98905 14.3741 9.57508 16.3304 12.0151 16.3304C14.4552 16.3304 16.0412 14.3741 16.0412 11.9898C16.0412 9.60556 14.4552 7.64924 12.0151 7.64924Z" fill="white"/>
                                        <defs>
                                        <linearGradient id="paint0_linear_10126_3637" x1="24" y1="24" x2="0" y2="0" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#FC6076"/>
                                        <stop offset="0.484375" stopColor="#FF4D66"/>
                                        <stop offset="1" stopColor="#FF6826"/>
                                        </linearGradient>
                                        </defs>
                                    </svg>
                                </Link>
                                <div className="wordpress__breadcrumbs_item wordpress__breadcrumbs_item--page">
                                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M7.18436 11.3545C7.62418 10.9476 7.62418 10.2524 7.18436 9.84554L3.02703 6L7.18436 2.15446C7.62418 1.74763 7.62418 1.05237 7.18436 0.645537C6.79045 0.281168 6.18252 0.281169 5.78861 0.645537L6.91406e-07 6L5.78861 11.3545C6.18252 11.7188 6.79045 11.7188 7.18436 11.3545Z" fill="#3E3E53" />
                                    </svg>
                                    <Link to={page_data.acf.breadcrumbs.breadcrumbs_main_page.url}><span>{page_data.acf.breadcrumbs.breadcrumbs_main_page.title}</span></Link>
                                </div>
                                <div className="wordpress__breadcrumbs_item">
                                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M7.18436 11.3545C7.62418 10.9476 7.62418 10.2524 7.18436 9.84554L3.02703 6L7.18436 2.15446C7.62418 1.74763 7.62418 1.05237 7.18436 0.645537C6.79045 0.281168 6.18252 0.281169 5.78861 0.645537L6.91406e-07 6L5.78861 11.3545C6.18252 11.7188 6.79045 11.7188 7.18436 11.3545Z" fill="#3E3E53" />
                                    </svg>
                                    <span>{page_data.acf.breadcrumbs.breadcrumbs_text}</span>
                                </div>
                            </div>
                            {window.innerWidth < 992 &&
                                <div className="post-contents">
                                    <div className="contents-title">{page_data.acf.contents.header}</div>
                                    <ol className="contents">
                                        {
                                            page_data.acf.contents.list.map((item, key) => {
                                                return (
                                                    <li>
                                                        <a href={item.href}><p>{item.text}</p></a>
                                                        {item.sublist &&
                                                            <ol>
                                                                {
                                                                    item.sublist.map((sublist_item, key) => {
                                                                        return (
                                                                            <li>
                                                                                <a href={sublist_item.href}><p>{sublist_item.text}</p></a>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ol>
                                                        }
                                                    </li>
                                                )
                                            })
                                        }
                                    </ol>
                                </div>
                            }
                            <div className="posting" dangerouslySetInnerHTML={{ __html: page_data.content.rendered }} />
                            {page_data.acf.show_contact_button &&
                                <div className='contact-block'>
                                    <div className='contact-block__bottom'>
                                        <div className="contact_bg">{postOptions.acf.contact_block.link.title}</div>    
                                    </div>
                                    <img src={postOptions.acf.contact_block.image.url} alt={postOptions.acf.contact_block.image.alt} />
                                    <a href={postOptions.acf.contact_block.link.url} className="contact-block__button">
                                        <i className="icon-envelope"></i>
                                        {postOptions.acf.contact_block.link.title}
                                    </a>
                                </div>
                            }
                        </div>
                        {!isMobile && <PostOtherTechnologies pageData={page_data}/>}
                    </div>
                </div>
                <PostProjects postName={'wordpress'} page_data={page_data} />
                {lastPosts[0] &&
                    <div className="wordpress__content__last-posts">
                        <h2 className="wordpress__content-right-title title-post">{page_data.acf.relevante_articles_title}</h2>
                        <PostList post={lastPosts} postType={'posts'} readMoreButton={page_data.acf.read_more_button_text} />
                    </div>
                }
                {isMobile && <PostOtherTechnologies pageData={page_data}/>}
            </>
        );
    } else {
        return (
            <>
                <div className="e-commerce-page e-commerce-page--preloader">
                    <Loader />
                </div>
            </>
        );
    }
};
export default Wordpress;
